// Session volatile partagée par les instances de l’API Clinique.
let session = null, sequence = 0
const instances = new WeakSet(), auditeurs = new Set()

export function terminerComplement(message = '') {
    session = null
    sequence++
    auditeurs.forEach(notifier => notifier(message))
}
export function observerComplement(notifier) {
    auditeurs.add(notifier)
    return () => auditeurs.delete(notifier)
}
export function ouvrirComplement(contexte, capacite, renouveler) {
    terminerComplement()
    session = { ...contexte, capacite, renouveler, sequence, renouvellement: null }
}
export function complementActif(consultationId) {
    return !!session && Number(session.consultation_id) === Number(consultationId)
}
export function verifierContexteComplement(patientId, consultationId) {
    if (session && (Number(session.patient_id) !== Number(patientId) || !complementActif(consultationId))) terminerComplement()
}
function versClinique(config, baseURL) {
    if (config.baseURL && config.baseURL !== baseURL) return false
    const base = new URL(baseURL.replace(/\/?$/, '/'), 'http://clinicaa.invalid/')
    const adresse = /^(?:[a-z][a-z\d+.-]*:)?\/\//i.test(config.url) ? config.url : String(config.url).replace(/^\//, '')
    const cible = new URL(adresse, base)
    return cible.origin === base.origin && cible.pathname.startsWith(base.pathname)
}
function capaciteValide(capacite) {
    try {
        const charge = capacite.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
        const exp = Number(JSON.parse(window.atob(charge)).exp)
        return Number.isFinite(exp) && exp * 1000 > Date.now() + 20000
    } catch (_) { return false }
}
async function renouvelerCapacite(etat) {
    if (capaciteValide(etat.capacite)) return etat.capacite
    if (!etat.renouvellement) etat.renouvellement = Promise.resolve().then(etat.renouveler).then(reponse => {
        if (!reponse || !reponse.success || !reponse.data || !reponse.data.access_token) {
            throw new Error('Autorisation de complément indisponible.')
        }
        etat.capacite = reponse.data.access_token
        return etat.capacite
    }).finally(() => { etat.renouvellement = null })
    return etat.renouvellement
}
// Refus de la garde de complément (serveur, § 2.7) : affichés au niveau du dossier. Les autres erreurs restent
// celles des rubriques qui les reçoivent.
const REFUS_COMPLEMENT = ['complement_autre_medecin', 'specialite_non_autorisee', 'validite_inconnue', 'modification_apres_cloture']
export function installerComplement(instance) {
    if (instances.has(instance)) return
    instances.add(instance)
    instance.interceptors.request.use(async config => {
        const etat = session
        if (!etat || !versClinique(config, instance.defaults.baseURL)) return config
        config.med_access_scoped = true
        config.complement_sequence = etat.sequence
        let capacite
        try { capacite = await renouvelerCapacite(etat) }
        catch (erreur) { throw Object.assign(new Error(erreur.message), { response: erreur.response, config }) }
        if (session !== etat) throw new Error('La session de complément a changé. Rouvrez le dossier.')
        config.headers = { ...(config.headers || {}), 'X-Med-Access': capacite }
        return config
    })
    instance.interceptors.response.use(reponse => reponse, erreur => {
        const reponse = erreur.response, config = erreur.config || {}, data = reponse && reponse.data || {}
        if (session && config.complement_sequence === session.sequence) {
            if (Number(reponse && reponse.status) === 409 && data.code === 'fenetre_complement_fermee') {
                terminerComplement(data.message || '')
            } else if (data.message && REFUS_COMPLEMENT.includes(data.code)) auditeurs.forEach(notifier => notifier(data.message))
        }
        return Promise.reject(erreur)
    })
}
